/**
	Docs: GEF_KCL_Přístupová práva.xlsx
*/

// SPECIAL
export const technicalAccess = [{ id: 9000 }];

export const TEMP_CAMPAIGN_DISABLE = [{ id: 2999 }];

// 1000 +
export const KCL_ACCESS_TO_KANCELAR = [{ id: 1000 }];

export const MPU_DISPLAY_TASK_LIST = [{ id: 1101 }];

export const MPU_DISPLAY_SUBUSER_LIST = [{ id: 1102 }];

export const MPU_DISPLAY_TASK_STATISTIC = [{ id: 1103 }];

export const MPU_DISPLAY_TASK_DETAIL = [{ id: 1104 }];

export const MPU_FULFILL_TASK = [{ id: 1105 }];

export const MPU_FORWARD_TASK = [{ id: 1106 }];

export const MPU_ADAPT_TASK = [{ id: 1107 }];

export const MPU_CREATE_MANUAL_TASK = [{ id: 1108 }];

export const MPU_PROCESSED_TASK = [{ id: 1109 }];

export const MPU_DISPLAY_SUBORD_TASK_LIST = [{ id: 1110 }];

export const MPU_SEARCH_TASK = [{ id: 1111 }];

export const MPU_ASSUME_TASK_OUTOFHIERARCHY = [{ id: 1112 }];

export const MPU_FULFILL_FOR_USER = [{ id: 1113 }];

export const MPU_FILTER_NOTIFICATION = [{ id: 1115 }];

export const MPU_FORWARD_TO_SUBUSER = [{ id: 1117 }];

export const MPU_FORWARD_TO_SUPERUSER = [{ id: 1118 }];

export const MPU_SEARCH_USERS = [{ id: 1119 }];

export const MPU_FORWARD_TO_AGENCY = [{ id: 1120 }];

export const MPU_FORWARD_TO_ALL = [{ id: 1122 }];

export const MPU_CHANGE_COMPLETION_TYPE = [{ id: 1124 }];

export const MPU_SEND_TASK_BY_MAIL = [{ id: 1126 }];

export const ALLOW_DEADLINE_DATE = [{ id: 1127 }];

export const MPU_CREATE_MOBILE_SCANNING_TASK = [{ id: 1128 }];

export const MPU_CREATE_BACKOFFICE_TASK = [{ id: 1132 }];

export const MPU_DISPLAY_LEAD_LIST = [{ id: 1133 }];

export const MPU_CREATE_LEAD = [{ id: 1134 }];

export const MPU_DISPLAY_LEAD_MARKET = [{ id: 1135 }];

export const MPU_DISPLAY_LEAD_DETAIL = [{ id: 1136 }];

export const MPU_TASK_SUBORDINATE_REPORT = [{ id: 1137 }];

export const MPU_CREATE_CONTACTCLIENT_TASK = [{ id: 1138 }];

export const MPU_PUSH_NOTIF = [{ id: 1201 }];

export const MPU_NOTIF_USER = [{ id: 1202 }];

export const MPU_NOTIF_SUP = [{ id: 1203 }];

export const MPU_NOTIF_TASKCOPY_USER = [{ id: 1204 }];

export const MPU_NOTIF_TASKCOPY_SUP = [{ id: 1205 }];

export const MPU_NOTIF_TASK_CREATION_FAIL = [{ id: 1206 }];

export const MPU_NOTIF_TASK_CREATION = [{ id: 1207 }];

export const MPU_NOTIF_ESC_LEAD_MARKET = [{ id: 1208 }];

export const MPU_NOTIF_ESC_LEAD_UNRESOLVED = [{ id: 1209 }];

export const MPU_NOTIF_ESC_REQ2SEL = [{ id: 1210 }];

export const MPU_NOTIF_SUMMARY_ESC_SUP = [{ id: 1211 }];

export const MPU_NOTIF_BACKOFFICE_TASK = [{ id: 1212 }];

export const MPU_NOTIF_SAN_MARCO = [{ id: 1213 }];

export const MPU_NOTIF_SMS = [{ id: 1214 }];

export const MPU_NOTIF_PUSH_MARKETPLACE = [{ id: 1216 }];

export const MPU_NOTIF_LOSSSME = [{ id: 1217 }];

// 2000 +
export const KMP_DISPLAY_CAMPAIGN_OVERVIEW = [{ id: 2000 }];

export const KMP_START_PRE_PRODUCTION = [{ id: 2100 }];

export const KMP_CRATE_CLOSE_PRODUCTION_SHEET = [{ id: 2101 }];

export const KMP_FUTURE_CAMPAIGN = [{ id: 2103 }];

export const KMP_CAMPAIGN_ADMINISTRATION = [{ id: 2104 }];

export const KMP_CAMPAIGN_SETTINGS = [{ id: 2105 }];

export const KMP_ORDER_AM = [{ id: 2106 }];

export const KMP_DEALER_NOMINATION = [{ id: 2107 }];

export const KMP_CONTACT_PROCESS = [{ id: 2108 }];

export const KMP_DISTRIBUTE_CONTACTS = [{ id: 2110 }];

export const KMP_NEW_CAMPAIGN = [{ id: 2112 }];

// 3000 +

export const DISPLAY_SUMMARY_OVERVIEW = [{ id: 3000 }];

export const DISPLAY_SUMMARY_OVERVIEW_MANAGER = [{ id: 3001 }];

export const DASHBOARD_ACLS = [...DISPLAY_SUMMARY_OVERVIEW, ...DISPLAY_SUMMARY_OVERVIEW_MANAGER];

// 4000 +
export const KCL_DISPLAY_POLICY_LIST = [{ id: 4000 }];

export const KCL_APPLY_POLICY_SUBSELLER_FILTER = [{ id: 4001 }];

export const KCL_DISPLAY_POLICY_LIST_ISP = [{ id: 4002 }];

export const KCL_DISPLAY_RA_ANALYSES = [{ id: 4005 }];

export const KCL_HANDOVER_RA_ANALYSES = [{ id: 4006 }];

export const KCL_DISPLAY_SUBORDINATE_RA_ANALYSES = [{ id: 4105 }];

export const KCL_DISPLAY_SUBORD_POLICY_LIST = [{ id: 4100 }];

export const KCL_DISPLAY_CONTACT_HISTORY = [{ id: 4101 }];

export const KCL_DISPLAY_SUBORDINATE_CONTACT_HISTORY = [{ id: 4102 }];

export const KCL_DISPLAY_UNLOCKED_CLIENTS = [{ id: 4003 }];

export const KCL_DISPLAY_SEMAPHORE = [{ id: 4007 }];

export const KCL_DISPLAY_SETTINGS = [{ id: 4008 }];

export const KCL_DISPLAY_DOCUMENT_CHECK = [{ id: 4009 }];

export const KCL_DISPLAY_DOCUMENT_CHECK_DETAIL = [{ id: 4010 }];

export const KCL_DOCUMENT_CHECK_ADMINS = [{ id: 4011 }];

export const KCL_DOCUMENT_CHECK_MARPO = [{ id: 4012 }];

export const KCL_DISPLAY_POLICY_LIST_SUBORD = [{ id: 4013 }];

export const KCL_DISPLAY_PROSPECTOR_LINK = [{ id: 4014 }];

export const KCL_AREA_SETTINGS = [{ id: 4015 }];

export const KCL_DISPLAY_SUBORD_UNLOCKED_CLIENTS_ICON = [{ id: 4103 }];

export const KCL_DISPLAY_SUBORDINATE_LEAD = [{ id: 4104 }];

export const KCL_DASHBOARD_PK = [{ id: 4106 }];

export const KCL_DASHBOARD_ISP = [{ id: 4107 }];

export const KCL_DASHBOARD_HUGO = [{ id: 4108 }];

export const KCL_DASHBOARD_CZP = [{ id: 4109 }];

export const KCL_DASHBOARD_DEBTS = [{ id: 4110 }];

export const KCL_DASHBOARD_LISA = [{ id: 4111 }];

export const KCL_DASHBOARD_LISA2 = [{ id: 4112 }];

export const KCL_DISPLAY_SUBORDINATE_SEMAPHORE = [{ id: 4113 }];

export const KCL_DISPLAY_SUBORDINATE_SETTINGS = [{ id: 4114 }];

export const KCL_DASHBOARD_SANMARCO = [{ id: 4115 }];

export const KCL_MENU_HELPIDK = [{ id: 4150 }];

export const KCL_MENU_HELPEDK = [{ id: 4151 }];
